import {useEffect} from 'react'
import './styles.css'
import tagInfo from './tagInfo';


import aos from "aos";
import 'aos/dist/aos.css'

export default function AboutMe () {

    useEffect(() => {
        aos.init({duration: 2000})
    })

    return (
        <div data-aos="zoom-in" className="about-me component">
                <h2>Sobre mi</h2>
                {
                    tagInfo
                }
        </div>
    )

}